import { Fragment, useMemo } from 'react';
import { AbsoluteFill, useCurrentFrame } from 'remotion';
import { TrackType } from '@goldcast/player-config/src/types/Track/Type';
import { ElementsTrack } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Track/ElementsTrack';
import { CompositionConfig } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import TrackComponent from '../components/TrackComponent/TrackComponent';
import { getTrackZIndex } from './utils/trackUtils';
import { useRemotionEnvVariables } from './ClipPlayerV2WithNewTimeline/hooks/useRemotionEnvVariables';
import { PlayerConfigMetadataProvider } from '../components/PlayerConfigMetadataProvider/PlayerConfigMetadataProvider';

const MainPlayer: React.FC<CompositionConfig> = ({
  playerConfig: { tracks, metadata },
  showPlayerFrames = false,
  onOutlineRelease,
  onOutlineResize,
  canEditCaptions = true,
  disableCaptionsDragging = false,
  disableCaptionsResize = true,
  canEditSpeakerLabel = false,
  canEditImages = false,
  canEditTextElements = false,
  canEditVideos = false,
  canManuallyReposition = false,
  preventOverlappingWithOtherCrops = false,
  canEditLottie = false
}) => {
  const frame = useCurrentFrame();
  const { burnFrameNumberInRenderOutput } = useRemotionEnvVariables();

  const elementTracks = useMemo(
    () => tracks.filter((t): t is ElementsTrack => t.type === TrackType.ELEMENTS),
    [tracks]
  );

  return (
    <Fragment>
      <AbsoluteFill
        id="remotion-main-player"
        className="content-lab-root pointer-events-none antialiased"
        style={{ containerType: 'size' }}
      >
        <PlayerConfigMetadataProvider metadata={metadata}>
          {tracks.map((track, index) => {
            if (track.hideTrack.inPlayer) {
              return null;
            }

            return (
              <div
                key={track.id}
                style={{
                  zIndex: getTrackZIndex(track, index, tracks)
                }}
              >
                <TrackComponent
                  track={track}
                  elementTracks={track.type === TrackType.CAPTIONS ? elementTracks : undefined}
                  onOutlineRelease={onOutlineRelease}
                  onOutlineResize={onOutlineResize}
                  canEditCaptions={canEditCaptions}
                  disableCaptionsDragging={disableCaptionsDragging}
                  disableCaptionsResize={disableCaptionsResize}
                  canEditSpeakerLabel={canEditSpeakerLabel}
                  canEditImages={canEditImages}
                  canEditTextElements={canEditTextElements}
                  canEditVideos={canEditVideos}
                  canManuallyReposition={canManuallyReposition}
                  preventOverlappingWithOtherCrops={preventOverlappingWithOtherCrops}
                  canEditLottie={canEditLottie}
                />
              </div>
            );
          })}
        </PlayerConfigMetadataProvider>
      </AbsoluteFill>
      {(showPlayerFrames || burnFrameNumberInRenderOutput) && (
        <div style={{ position: 'fixed', top: 0, left: 0, color: 'red', fontSize: 60 }}>{frame}</div>
      )}
    </Fragment>
  );
};

export default MainPlayer;
